/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as router from 'store/ducks/router';

export default function LocationTracker(): JSX.Element {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const curLocation = `${location.pathname}${location.search}`;
    dispatch(router.ActionCreators.locationChanged(curLocation));
  }, [dispatch, location]);

  return <></>;
}
